import { createService } from '../../createService';

export const StandardBetService = createService({
  title: 'Ваша ставка',
  subTitle: 'Стандарт',
  description: ['Ниже Топа и Премиума,', 'Не выделяется в поиске'],
  dataName: 'StandardBetService',
  bgColor: 'white',
  icon: null,
});
